module.exports = __webpack_public_path__ + "static/img/appPage_4.0389b50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/appPage_4.png
// module id = UiAp
// module chunks = 1